import React, { useState } from 'react'
import { Modal, Form, Input, Button, message } from 'antd'
import { LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const ChangePasswordModal = ({ visible, onClose }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const { changePassword } = useAuth()

  const handleSubmit = async (values) => {
    setLoading(true)
    
    try {
      const result = await changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword
      })
      
      if (result.success) {
        onClose()
        form.resetFields()
      }
    } catch (error) {
      console.error('Password change error:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancel = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title="เปลี่ยนรหัสผ่าน"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={480}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        size="large"
        requiredMark={false}
      >
        <Form.Item
          name="currentPassword"
          label="รหัสผ่านปัจจุบัน"
          rules={[
            {
              required: true,
              message: 'กรุณาระบุรหัสผ่านปัจจุบัน'
            }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="รหัสผ่านปัจจุบันของคุณ"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="รหัสผ่านใหม่"
          rules={[
            {
              required: true,
              message: 'กรุณาระบุรหัสผ่านใหม่'
            },
            {
              min: 6,
              message: 'รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร'
            }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="รหัสผ่านใหม่"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="ยืนยันรหัสผ่านใหม่"
          dependencies={['newPassword']}
          rules={[
            {
              required: true,
              message: 'กรุณายืนยันรหัสผ่านใหม่'
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve()
                }
                return Promise.reject(new Error('รหัสผ่านไม่ตรงกัน'))
              },
            })
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="ยืนยันรหัสผ่านใหม่"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            ยกเลิก
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            เปลี่ยนรหัสผ่าน
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ChangePasswordModal